import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberUtil } from 'google-libphonenumber';

interface ParsedPhoneNumber {
  getCountryCode: () => number;
  getNationalNumber: () => number;
}

const phoneNumberUtil = PhoneNumberUtil.getInstance();

@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {

  transform(value: string, fallbackRegion: string = 'US'): string {
    if (!value) return '';

    const rawValue = value.trim();
    const digits = value.replace(/\D/g, '');

    if (!digits) {
      return rawValue;
    }

    const parseCandidates = rawValue.startsWith('+') || digits.length > 10
      ? [`+${digits}`, rawValue]
      : [rawValue];

    for (const parseCandidate of parseCandidates) {
      try {
        const parsedPhoneNumber = phoneNumberUtil.parse(
          parseCandidate,
          fallbackRegion.toUpperCase()
        );

        if (phoneNumberUtil.isPossibleNumber(parsedPhoneNumber)) {
          return this.formatParsedPhoneNumber(parsedPhoneNumber as ParsedPhoneNumber);
        }
      } catch {
        continue;
      }
    }

    return rawValue;
  }

  private formatParsedPhoneNumber(parsedPhoneNumber: ParsedPhoneNumber): string {
    const countryCode = parsedPhoneNumber.getCountryCode();
    const nationalNumber = String(parsedPhoneNumber.getNationalNumber());

    if (nationalNumber.length < 7) {
      return `+${countryCode} ${nationalNumber}`;
    }

    const areaCode = nationalNumber.slice(0, 3);
    const prefix = nationalNumber.slice(3, 6);
    const lineNumber = nationalNumber.slice(6);

    return `+${countryCode} (${areaCode}) ${prefix}-${lineNumber}`;
  }
}
